module.exports = __webpack_public_path__ + "img/imagen9.a854ccae.png";